import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconColor } from '../icon';
import {
  LinkColor,
  LinkHoverColor,
  LinkIconPosition,
  LinkWeight,
} from '../link';
import { LinkModule } from '../link/link.module';
import { TextSize } from '../text';

@Component({
  standalone: true,
  imports: [LinkModule],
  selector: 'fl-section-homepage-feature-footer',
  template: `
    <p class="text-light text-body-20 desktop:text-title-32 font-bold">
      {{ footerCopy }}
    </p>
    <fl-link
      flTrackingLabel="flFooterTrackingLabel"
      [color]="LinkColor.PRIMARY"
      [iconColor]="IconColor.PRIMARY"
      [iconName]="'ui-arrow-right'"
      [iconPosition]="LinkIconPosition.RIGHT"
      [hoverColor]="LinkHoverColor.PRIMARY"
      [link]="footerUrl"
      [size]="TextSize.BODY_20"
      [weight]="LinkWeight.BOLD"
    >
      {{ footerLink }}
    </fl-link>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHomepageFeatureFooterComponent {
  IconColor = IconColor;
  LinkColor = LinkColor;
  LinkHoverColor = LinkHoverColor;
  LinkIconPosition = LinkIconPosition;
  LinkWeight = LinkWeight;
  TextSize = TextSize;

  @Input() footerCopy: string;
  @Input() footerLink: string;
  @Input() footerUrl: string;
  @Input() flFooterTrackingLabel: string;
}
